import React from 'react';
import { Link } from 'react-router-dom';
import { HelpCircle } from 'lucide-react';

/**
 * A link from a page to the help for that page.
 *
 * Sits in the page header rather than behind a global help menu: someone
 * confused by maintenance windows wants the page about maintenance windows,
 * not an index to search.
 */
export function HelpLink({ topic, label = 'Help' }: { topic: string; label?: string }) {
  return (
    <Link
      to={`/help/${topic}`}
      className="btn btn-ghost btn-sm"
      title={`Help: ${label}`}
      aria-label={`Help: ${label}`}
    >
      <HelpCircle size={14} /> Help
    </Link>
  );
}
